import type { I18n } from '@change-corgi/core/i18n';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PageTitle } from '#src/shared/pageHead';

import { isLoaded } from '#src/app/shared/utils/async';

import type { PetitionDetailsPageHeadData } from './types';

export function petitionDetailsPageTitle({
	prefetchedData,
	i18n,
	fromTemplate,
}: {
	prefetchedData: PetitionDetailsPageHeadData;
	i18n: I18n | UtilityContext['i18n'];
	fromTemplate: (title: string) => PageTitle | string;
}): string | PageTitle | undefined {
	if (!isLoaded(prefetchedData.pageData)) {
		return undefined;
	}

	const { ask, city, country } = prefetchedData.pageData.pageData.petition;
	const countryName = country.displayName || undefined;

	let title = `${i18n.translate('fe.pages.petition_show.title')} · ${ask}`;

	if (city && countryName) title += ` - ${city}, ${countryName}`;
	else if (countryName) title += ` - ${countryName}`;

	return fromTemplate(title);
}
